import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type TabKey =
  | "home"
  | "leagues-home"
  | "tournaments"
  | "matches"
  | "teams"
  | "gallery"
  | "about"
  | "squads"
  | "documents"
  | "requests"
  | "grounds"
  | "players"
  | "waiver"
  | null;

interface ActiveTabState {
  value: TabKey;
}

const initialState: ActiveTabState = {
  value: "home",
};

const activeTabSlice = createSlice({
  name: "activeTab",
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<TabKey>) {
      state.value = action.payload;
    },
    resetActiveTab() {
      return initialState;
    },
  },
});

export const { setActiveTab, resetActiveTab } = activeTabSlice.actions;
export default activeTabSlice.reducer;
